import React, { Component } from "react";
import { Row, Col, Container } from "react-bootstrap";
import PropTypes from "prop-types";
import { sanitizeUrl } from "@braintree/sanitize-url";
import queryString from "query-string";
import { v4 as uuidv4 } from 'uuid';
import {
  getNestedObject,
  getLoginUrl,
  getRoutePath,
  setSessionValue,
  setLocalStorageValue,
  getSessionValue,
  getFormattedPhoneNumberFromUSFormat,
  logoutTimer,
  removeSessionValue,
  getLocalStorageValue,pageNotFound
} from "../../utils/common";
import ProfileLeftMenu from "./ProfileLeftMenu";
import http from "../../api/http-request";
import LandingPage from "./landingPage";
import PersonalInformation from "./PersonalInformation";
import LoginAndSecurity from "./LoginAndSecurity";
import Preferences from "./Preferences";
import BackToButton from "./BackToButton";
import IdentityVerification from "../IdentityVerification";
import SomethingWentWrong from "../common/SomethingWentWrong";
import {setCookie } from "../../utils/cookies";
import i18n from "../../i18n";
import { withRouter } from "react-router-dom";
class Profile extends Component {
  constructor(props) {
    super(props);
    this.rightSectionRef = React.createRef();
    this.state = {
      isLoggedInUser: false,
      gotToken: false,
      userId: "",
      lastLoginTimestamp: "",
      userData: {
        userName: "",
        mail: "",
        telephoneNumber: "",
        givenName: "",
        middleName:"",
        sn: "",
        emailValidated: false,
        preferredLanguage:"",
        title:"",
        suffix:"",
        alternatecontactNumber: "",
        mfaEnrolled:"",
      },
      isRole:false,
      isError:false,
      preferredMFAMode:"",
      MFA:false,
      getAccessTokenPayLoad: {},
      saveChanges:false,
      savedChanges:false,
      disableSave:false,
      deviceProfile:[],
      disableMfa:"",
      navigateMobile:false
    };
    this.patch = [{
      "operation":"replace",
      "field":"",
      "value":""
    }]
  }

  componentDidMount() {
    const {
      location: { search }
    } = this.props;
    const {
      code,
      iss,
      state,
      client_id,
      action,
      spEntityID,
      RelayState,
      goto      
    } = queryString.parse(search);
    if (window.location.pathname === '/ctidentity/profile/personalInformation') {
      sessionStorage.setItem('locationUrl', window.location.pathname);
    } else if (window.location.pathname === '/ctidentity/profile/loginAndSecurity') {
      sessionStorage.setItem('locationUrl', window.location.pathname);
    } else if (window.location.pathname === '/ctidentity/profile/preferences') {
      sessionStorage.setItem('locationUrl', window.location.pathname);
    }
    if (action && action === "idproofing") {
      setSessionValue("idproofingParams", search);
    } else if ((spEntityID && RelayState)||(goto)) {
      setLocalStorageValue("backTo", search);
      if (getSessionValue("idproofingParams")) {
        removeSessionValue("idproofingParams");
      }
    }
    const { gotToken } = this.state;
    if (!code || (!iss && !gotToken)) {
      this.isAuthenticated();
    }
    if (code && iss && state && client_id) {
      this.getToken(code, iss, state, client_id);
    }
    logoutTimer();
    this.setState({
      isError : false
    });
    window.addEventListener('popstate', this.handleBackButton);
    // document.getElementById('randomClick').click();
  }
  componentWillUnmount() {
    // Remove event listener when the component is unmounted
    window.removeEventListener('popstate', this.handleBackButton);
  }
  handleBackButton = (event) =>{
    event.preventDefault();
    const {history,history:{location:{pathname}}} = this.props
    console.log(pathname,history)
    if(pathname === '/ctidentity/profile'){
      this.isAuthenticated()
    }
  }
  getAPIHeaders = () => {
    return {
      'Content-Type': 'application/x-www-form-urlencoded',
    };
  };

  getHeaders = () => {
    const dataStoreToken = localStorage.getItem("authToken");
    const bearer = 'Bearer ';
    return {
      Authorization: `${bearer}${dataStoreToken}`,
    };
  };

  componentDidUpdate(prevProps) {
    const {
      match: { params }
    } = this.props;
    if (
      prevProps.match.params !== params &&
      !getLocalStorageValue("isUserLogin")
    ) {
      this.isLooggedIn();
    }
   
    
  }
  

  isLooggedIn = () => {
    http(
      {
        url: "sessions/?_action=getSessionInfo",
        method: "POST"
      },
      {
        "Accept-API-Version": "protocol=1.0,resource=2.1"
      }
    )
  };

  isAuthenticated = () => {
    http(
      {
        url: "authenticate",
        method: "POST"
      },
      {
        "Accept-API-Version": "protocol=1.0,resource=2.1"
      }
    ).then((res) => {
     
      if (res.status === 200 && res.data && (res.data.successUrl || res.data.authId)) {
        if (getNestedObject(res, ["data", "authId"])) {
          window.location.href = sanitizeUrl(getLoginUrl());
        } else if (getNestedObject(res, ["data", "successUrl"])) {
          this.sendRequestToForgeRock();
        }
      } 
      else if(res.status === 200 && res.data && typeof res.data === 'string'){
        pageNotFound(res);
      }
      else {
        this.setState({
          isError : true
        });
        
      }
    });
  };

  sendRequestToForgeRock = () => {
    const uuid = uuidv4();
    const locationUUrl = window.location.origin;
    http(
      {
        url: `authorize?response_type=code&client_id=end-user-ui&scope=openid fr:idm:*&redirect_uri=${locationUUrl}/ctidentity/profile&state=${uuid}`,
        method: "GET"
      },
      { ...this.getAPIHeaders() }
    ).then(() => {
      const locationUrl = window.location.origin;
      let urlEnv;
      if (locationUrl.indexOf('dev.login.ct.gov') > 0) {
        urlEnv = `${locationUrl}/openam/oauth2/realms/root/realms/BOSCitizens/authorize?response_type=code&client_id=end-user-ui&scope=openid%20fr:idm:*&redirect_uri=${locationUrl}/ctidentity/profile&state=${uuid}`;
      } else {
        urlEnv = `${locationUrl}/oauth2/realms/root/realms/boscitizens/authorize?response_type=code&client_id=end-user-ui&scope=openid%20fr:idm:*&redirect_uri=${locationUrl}/ctidentity/profile&state=${uuid}`;
      }
      window.location.href = sanitizeUrl(urlEnv);
    });
  };



  getToken = (code, iss, state, clientId) => {
    const locationUrl = window.location.origin;
    const { getAccessTokenPayLoad } = this.state;
    getAccessTokenPayLoad.code = code;
    getAccessTokenPayLoad.client_id = clientId;
    getAccessTokenPayLoad.grant_type = 'authorization_code';
    getAccessTokenPayLoad.redirect_uri = `${locationUrl}/ctidentity/profile`;
    http(
      {
        url: "access_token",
        method: "POST",
        data: queryString.stringify(getAccessTokenPayLoad),
      },
      { ...this.getAPIHeaders() }
    ).then((res) => {
      const token = getNestedObject(res, ["data", "access_token"]);
      localStorage.setItem("authToken", token);
      if (res.status === 200 && token) {
        this.getUserId(token);
        const { history } = this.props;
        if (getSessionValue("idproofingParams")) {
          // history.push(sanitizeUrl(`${getRoutePath}/profile/identityVerification`));
          // remove below line and uncomment above line for id-proofing
          history.push(sanitizeUrl(`${getRoutePath}/profile`));
        } else if (sessionStorage.getItem('locationUrl') === null) {
          history.push(sanitizeUrl(`${getRoutePath}/profile`));  
        } else if (sessionStorage.getItem('locationUrl') === '/ctidentity/profile/preferences') {
          history.push(sanitizeUrl(`${getRoutePath}/profile/preferences`));
        } else if (sessionStorage.getItem('locationUrl') === '/ctidentity/profile/personalInformation' && sessionStorage.getItem('locationUrl') !== null) {
          history.push(sanitizeUrl(`${getRoutePath}/profile/personalInformation`));
          sessionStorage.setItem('locationUrl', null);  
        } else if (sessionStorage.getItem('locationUrl') === '/ctidentity/profile/loginAndSecurity' && sessionStorage.getItem('locationUrl') !== null) {
          history.push(sanitizeUrl(`${getRoutePath}/profile/loginAndSecurity`));
          sessionStorage.setItem('locationUrl', null);
        } else {
          history.push(sanitizeUrl(`${getRoutePath}/profile`));
        }
        this.setState({
          gotToken: true
        });
      } 
      else if(res.status === 200 && res.data && typeof res.data === 'string'){
        pageNotFound(res);
      }
      else {
        this.setState({
          isError : true
        });
      }
    });
  };
  checkPreferredMethod = (pMethod) =>{
    if(pMethod === "NA" || pMethod === undefined || pMethod === null){
      return "EMAIL"
    } else {
      return pMethod
    }
  }
  checkMFA = (mfa) =>{
    if(mfa === "true"){
      return true
    } else {
      return false
    }
  }
  getUserId = (token) => {
    const bearer = 'Bearer ';
    http(
      {
        url: "info/login",
        method: "GET"
      },
      {
        Authorization: `${bearer}${token}`,
      }
    ).then((res) => {
      let isRole = false;
      if(res.data.authorization.roles){
        const idmrole = res.data.authorization.roles;
          if(idmrole.length > 0){
          idmrole.map(function(item,i){
            if(item === 'internal/role/openidm-ctadmin' || item === 'internal/role/openidm-help-desk' || item === 'internal/role/openidm-pdms-admin'){
              setCookie("AMDatastoreToken", localStorage.getItem("authToken"));
              setCookie("resubmitDataStoreToken", 'true');
              isRole = true;
            } 
          })
        }
      }
      if (res.status === 200 && res.data && res.data.authorization.id) {
        this.getUserDetails(res.data.authorization.id, token,isRole);
        setLocalStorageValue("isUserLogin", "1");
      }
      else if(res.status === 200 && res.data && typeof res.data === 'string'){
        pageNotFound(res);
      }
    });
  };

  getUserDetails = (id, token,isRole) => {
    this.setState({
      userId: id,
      userDetailsToken: token
    });
    if(isRole){
      this.setState({isRole:true})
    } else{
      this.setState({isRole:false})
    }
    const bearer = 'Bearer ';
   
    http(
      {
        url: `managed/user/${id}?&_fields=userName,givenName,middleName,title,sn,suffix,emailValidated,phoneValidated,telephoneNumber,alternatecontactNumber,mail,preferences/preferredLanguage,mfaEnrolled,preferredMFAMode,appEnrolled,memberOfRoleIDs`,
        method: "GET"
      },
      {
        Authorization: `${bearer}${token}`,
      }
    ).then((res) => {
      if (res.status === 200 && res.data && res.data.userName) {
        const { setUserDetails } = this.props;
        setUserDetails(res.data);
        this.setState({
          isLoggedInUser: true,
          userData: {
            ...res.data,
            telephoneNumber: getFormattedPhoneNumberFromUSFormat(
              res.data.telephoneNumber
            ),
            alternatecontactNumber: getFormattedPhoneNumberFromUSFormat(
              res.data.alternatecontactNumber
            ),
            preferredLanguage:res.data.preferredLanguage,
            mfaEnrolled:this.checkMFA(res.data.mfaEnrolled),
            preferredMFAMode:this.checkPreferredMethod(res.data.preferredMFAMode)
          },
          MFA:this.checkMFA(res.data.mfaEnrolled),
          preferredMFAMode:this.checkPreferredMethod(res.data.preferredMFAMode)
        });
        if(res.data.preferences){
          const languagePref = res.data.preferences;
          const lan = languagePref.preferredLanguage;
          if(lan === 'en'){
            i18n.changeLanguage("en_US");
            setCookie("ctsessionlanguage", "en_US");
          } else {
            i18n.changeLanguage(lan);
            setCookie("ctsessionlanguage", lan);
          }
         
        }
        if(res.data && res.data.memberOfRoleIDs && res.data.memberOfRoleIDs.length > 0){
          for(const role in res.data.memberOfRoleIDs){
            if(res.data.memberOfRoleIDs[role] && res.data.memberOfRoleIDs[role] === 'CTAdmin'){
              this.setState({
                isRole:true
              })
              break;
            }
          }
        }
         
        this.getLastLogon(res.data.userName);
        this.getDeviceProfiles(res.data.userName);
      }
      else if(res.status === 200 && res.data && typeof res.data === 'string'){
        pageNotFound(res);
      }
      else {
        this.setState({
          isError : true
        });
      }
    });
  };

  getUpdatedName = () => {
        let token = localStorage.getItem("authToken");
        this.getUserId(token);
  }

  getUpdatedMobileNumber = () => {
    const { userId } = this.state;
    http(
      {
        url: `managed/user/${userId}?&_fields=telephoneNumber,phoneValidated`,
        method: "GET"
      },
      { ...this.getHeaders() }
    ).then((res) => {
      if (res.status === 200 && res.data && res.data._id) {
        this.setState((prevState) => ({
          userData: {
            ...prevState.userData,
            telephoneNumber: getFormattedPhoneNumberFromUSFormat(
              res.data.telephoneNumber
            ),
          phoneValidated:res.data.phoneValidated
          }
        }));
      } 
      else if(res.status === 200 && res.data && typeof res.data === 'string'){
        pageNotFound(res);
      }
      else {this.setState({
        isError : true
      });}
    });
  };

  getUpdatedAlternateMobileNumber = () => {
    const { userId } = this.state;
    http(
      {
        url: `managed/user/${userId}?&_fields=alternatecontactNumber`,
        method: "GET"
      },
      { ...this.getHeaders() }
    ).then((res) => {
      if (res.status === 200 && res.data && res.data._id) {
        this.setState((prevState) => ({
          userData: {
            ...prevState.userData,
            alternatecontactNumber: getFormattedPhoneNumberFromUSFormat(
              res.data.alternatecontactNumber
            ),
          }
        }));
      } 
      else if(res.status === 200 && res.data && typeof res.data === 'string'){
        pageNotFound(res);
      }
      else {this.setState({
        isError : true
      });}
    });
  };

  getVerifiedMobileNumber = () => {
    const { userId } = this.state;
    http(
      {
        url: `managed/user/${userId}?&_fields=telephoneNumber,phoneValidated`,
        method: "GET"
      },
      { ...this.getHeaders() }
    ).then((res) => {
      if (res.status === 200 && res.data && res.data._id) {
        this.setState((prevState) => ({
          userData: {
            ...prevState.userData,
            telephoneNumber: getFormattedPhoneNumberFromUSFormat(
              res.data.telephoneNumber
            ),
            phoneValidated:res.data.phoneValidated
          }
        }));
      } 
      else if(res.status === 200 && res.data && typeof res.data === 'string'){
        pageNotFound(res);
      }
      else {this.setState({
        isError : true
      });}
    });
  };
  getUpdatedAppEnrolled = (val) => {
    const { userId } = this.state;
    http(
      {
        url: `managed/user/${userId}?&_fields=appEnrolled,preferredMFAMode,mfaEnrolled`,
        method: "GET"
      },
      { ...this.getHeaders() }
    ).then((res) => {
      if (res.status === 200 && res.data && res.data._id) {
        this.setState((prevState) => ({
          userData: {
            ...prevState.userData,
            appEnrolled:res.data.appEnrolled,
            mfaEnrolled:val? true :this.checkMFA(res.data.mfaEnrolled),
            preferredMFAMode:this.checkPreferredMethod(res.data.preferredMFAMode)
          },
          MFA:this.checkMFA(res.data.mfaEnrolled),
          preferredMFAMode:this.checkPreferredMethod(res.data.preferredMFAMode)
        }));
      } 
      else if(res.status === 200 && res.data && typeof res.data === 'string'){
        pageNotFound(res);
      }
      else {this.setState({
        isError : true
      });}
    });
  };

  getLastLogon = (userName) => {
    http(
      {
        url: `users/${encodeURIComponent(userName)}?_fields=lastLoginTimestamp`,
        method: "GET"
      },
      {
        "Accept-API-Version": "protocol=2.1,resource=4.0"
      }
    ).then((res) => {
      const timeStamp = getNestedObject(res, ["data", "lastLoginTimestamp"]);
      if (res.status === 200 && timeStamp) {
        this.setState({
          lastLoginTimestamp: timeStamp[0]
        });
      } else if (res.status === 403 && res.data.code === 403) {
        this.setState({
          lastLoginTimestamp: ""
        });
      } else if (res.status === 200 && res.data && typeof res.data === 'string') {
        pageNotFound(res);
      } else {
        this.setState({
          isError : true
        });
      }
    });
  };
  getDeviceProfiles = (userName) => {
    http(
      {
        url: `users/${encodeURIComponent(userName)}/devices/profile/?_queryId=*`,
        method: "GET"
      },
      {
        "Accept-API-Version": "protocol=2.1,resource=1.0"
      }
    ).then((res) => {
      const result = getNestedObject(res, ["data", "result"]);
      if (res.status === 200 && result) {
        this.setState({
          deviceProfile: result
        });
      } else if (res.status === 403 && res.data.code === 403) {
        this.setState({
          deviceProfile: []
        });
      } else if (res.status === 200 && res.data && typeof res.data === 'string') {
        pageNotFound(res);
      } else {
        this.setState({
          isError : true
        });
      }
    });
  };
  updateMfaEnrolled = (value) =>{
    const {emailValidated} = this.state.userData;
    if(emailValidated === 'false' || emailValidated=== null){
      this.setState({
        disableMfa:"success"
      },()=>{
        setTimeout(()=>{
          this.setState({
            disableMfa:""
          })
        },5000)
      })
      return;
    }
    this.setState((prevState)=>({
      userData:{
        ...prevState.userData,
        mfaEnrolled:value
      },
      saveChanges:true
    }))
  }
  unConfigureAuthenticatorHandler = (value) =>{
    const { userId } = this.state;
    this.patch[0].field = "/appEnrolled"; 
    this.patch[0].value=value.toString(); 
    http({
      url: `managed/user/${userId}`,
      method: "PATCH",
      data:this.patch
    },
    { ...this.getHeaders() }).then((res) => {
      if(res.status === 200 && res.data && res.data.appEnrolled){
        this.setState((prevState)=>({
          userData:{...prevState.userData,
          mfaEnrolled:true,
          appEnrolled:res.data.appEnrolled,
          preferredMFAMode:this.checkPreferredMethod(res.data.preferredMFAMode)
        },
        MFA:this.checkMFA(res.data.mfaEnrolled),
        preferredMFAMode:this.checkPreferredMethod(res.data.preferredMFAMode)
          }))
      } else {
        this.setState((prevState)=>({
          userData:{
            ...prevState.userData,
            mfaEnrolled:true,
            appEnrolled:"false"
          }
        }))
      }
    })
  }
  changePrefferedMode = (value) =>{
    const {phoneValidated,appEnrolled} = this.state.userData;
    if((value==="SMS" || value==="CALL") && (phoneValidated === null || phoneValidated==="false" )){
      return
    } else if(value==="AUTHENTICATOR" && (appEnrolled === null || appEnrolled === "false")){
      return
    }
    this.setState({
      preferredMFAMode:value,
      saveChanges:true
    })
  }
  savePreferredMethod = (e) =>{
    e.preventDefault();
    const {userId,preferredMFAMode,userData} = this.state;
    const {mfaEnrolled,userName} =userData;
    this.setState({
      disableSave:true
    })
    if(mfaEnrolled){
      const data=[{
        "operation":"replace",
        "field":"/mfaEnrolled",
        "value":"true"
      },
      {
        "operation":"replace",
        "field":"/preferredMFAMode",
        "value":""
      }]
      data[1].value=preferredMFAMode;
      http({
        url: `managed/user/${userId}`,
        method: "PATCH",
        data:data
      },
      { ...this.getHeaders() }).then((res) => {
        if(res.status === 200 && res.data && res.data.mfaEnrolled){
          this.getDeviceProfiles(userName)
          this.setState((prevState)=>({
            userData:{
              ...prevState.userData,
              preferredMFAMode:this.checkPreferredMethod(res.data.preferredMFAMode),
              mfaEnrolled:this.checkMFA(res.data.mfaEnrolled)
            },
            preferredMFAMode:this.checkPreferredMethod(res.data.preferredMFAMode),
            saveChanges:false,
            savedChanges:"success",
            MFA:this.checkMFA(res.data.mfaEnrolled),
            disableSave:false
            }),
            ()=>{
              setTimeout(()=>{
                this.setState({
                  savedChanges:""
                })
              },5000)
          })  
        } else {
          this.setState({
            savedChanges:"error"
          },
          ()=>{
            setTimeout(()=>{
             this.setState({
              savedChanges:""
             })
            },5000)
          })
        }
      })
    } else{
      const { userId } = this.state;
      this.patch[0].field = "/mfaEnrolled"; 
      this.patch[0].value=mfaEnrolled.toString(); 
      http({
        url: `managed/user/${userId}`,
        method: "PATCH",
        data:this.patch
      },
      { ...this.getHeaders() }).then((res) => {
        if(res.status === 200 && res.data && res.data.mfaEnrolled){
          this.setState((prevState)=>({
            userData:{...prevState.userData,
            mfaEnrolled:this.checkMFA(res.data.mfaEnrolled),
            preferredMFAMode:this.checkPreferredMethod(res.data.preferredMFAMode)
          },
          preferredMFAMode:this.checkPreferredMethod(res.data.preferredMFAMode),
          saveChanges:false,
          savedChanges:"success",
          MFA:this.checkMFA(res.data.mfaEnrolled),
          disableSave:false
          }),
          ()=>{
            setTimeout(()=>{
              this.setState({
                savedChanges:""
              })
            },5000)
          }
          )
          console.log(this.state)
        } else {
          this.setState(()=>({
            savedChanges:"error"
          }),
          ()=>{
            setTimeout(()=>{
              this.setState({
                savedChanges:""
              })
            },5000)
          }
          )
        }
      })
    }
  }
  cancelMfaPrefHandler = () =>{
    const { MFA , userData} = this.state;
    const { preferredMFAMode } = userData;
    this.setState((prevState)=>({
      userData:{
        ...prevState.userData,
        mfaEnrolled:MFA
      },
      preferredMFAMode:preferredMFAMode,
      saveChanges:false
    }))
  }
  navigateMobileHandler = (value) =>{
    this.setState({
      navigateMobile:value
    })
  }
  render() {
    const {
      match: {
        params: { pageName }
      }
    } = this.props;
    const { isLoggedInUser, userData, lastLoginTimestamp, userId, isError, isRole, preferredMFAMode, saveChanges, savedChanges, disableSave, deviceProfile, MFA, disableMfa, navigateMobile } = this.state;
    const { sn, givenName, userName} = userData;

    return (
      <>
        {isLoggedInUser && !isError &&
          (pageName === "identityVerification" ? (
            <IdentityVerification userInfo={{ sn, givenName, userName }} />
          ) : (
            <Container fluid className={`profile ${navigateMobile?'overlay':''}`}>
              <Row noGutters className="profile__row">
                <Col
                  md={{ span: 12 }}
                  lg={{ span: 3 }}
                  className="profile__row__left"
                >
                  <ProfileLeftMenu
                    pageName={pageName || ""}
                    rightSection={this.rightSectionRef}
                    isRole={isRole}
                    navigate={this.navigateMobileHandler}
                    showMenu={navigateMobile}
                  />
                </Col>
                <Col
                  md={{ span: 12 }}
                  lg={{ span: 9 }}
                  className="profile__row__right"
                  ref={this.rightSectionRef}
                >
                  <BackToButton />
                  {!pageName && (
                    <LandingPage />
                  )}
                  {pageName === "preferences" && (
                     <Preferences
                     userId={userId}
                     userData={userData}
                     getUpdatedMobileNumber={() => {
                       this.getUpdatedMobileNumber();
                     }}
                   />
                   )}
                  {pageName === "loginAndSecurity" && (
                    <LoginAndSecurity
                      lastLoginTimestamp={lastLoginTimestamp}
                      userId={userId}
                      userData={userData}
                      preferredMFAMode={preferredMFAMode}
                      mfa={MFA}
                      updatemfa={this.updateMfaEnrolled}
                      modeChange={this.changePrefferedMode}
                      saveMode={this.savePreferredMethod}
                      getUpdatedMobileNumber={() => {
                        this.getUpdatedMobileNumber();
                      }}
                      getVerifiedMobileNumber={() => {
                        this.getVerifiedMobileNumber();
                      }}
                      unConfigureAuthenticator={this.unConfigureAuthenticatorHandler}
                      getAppEnrolled={this.getUpdatedAppEnrolled}
                      saveChanges={saveChanges}
                      savedChanges={savedChanges}
                      disableSave={disableSave}
                      cancelMfaPref={this.cancelMfaPrefHandler}
                      deviceProfile = {deviceProfile}
                      getDeviceProfiles={this.getDeviceProfiles}
                      disableMfa={disableMfa}
                      getUpdatedName={() => {
                        this.getUpdatedName();
                      }}

                    />
                  )}
                  {pageName === "personalInformation" && (
                   
                    <PersonalInformation
                      userData={userData}
                      getUpdatedMobileNumber={() => {
                        this.getUpdatedMobileNumber();
                      }}
                      getUpdatedAlternateMobileNumber={() => {
                        this.getUpdatedAlternateMobileNumber();
                      }}
                      userId={userId}
                      getUpdatedName={() => {
                        this.getUpdatedName();
                      }}
                      getVerifiedMobileNumber={() => {
                        this.getVerifiedMobileNumber();
                      }}
                    />
                  )}
                </Col>
                
              </Row>
            </Container>
          ))}
          {isError  && (
                  <SomethingWentWrong />
                  
                )}
      </>
    );
  }
}

Profile.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  setUserDetails: PropTypes.func.isRequired
};
export default withRouter(Profile);